import { CONSULT_TYPE, CONSULT_STATUS, CONSULT_ACTION} from '@/lib/constants'

export const nameByConstMixin = {
  methods: {
    consult_type_text(const_val) {
      if (const_val === CONSULT_TYPE.QUICK) return '즉시'
      if (const_val === CONSULT_TYPE.BOOKING) return '예약'
    },
    consult_time_text(const_val) {
      //alert(const_val)
      if (const_val === null) return ''
      if (const_val !== null) return const_val
    },
    consult_status_text(const_val) {
      if (const_val === CONSULT_STATUS.INIT) return '접수완료(결제대기중)'
      if (const_val === CONSULT_STATUS.PAID) return '결제완료(수락대기중)'
      if (const_val === CONSULT_STATUS.READY) return '상담확정'
      if (const_val === CONSULT_STATUS.ON_COUNSULT) return '상담중'
      if (const_val === CONSULT_STATUS.DONE) return '종료'
      if (const_val === CONSULT_STATUS.CANCEL) return '취소'
    },
    consult_action_text(const_val) {
      if (const_val === CONSULT_ACTION.ADMIT) return '예약 승인'
      if (const_val === CONSULT_ACTION.ENTER) return '(PUSH) 상담실 입장 요청'
      if (const_val === CONSULT_ACTION.START) return '(PUSH) 상담시작 요청'
      if (const_val === CONSULT_ACTION.EXTEND) return '상담중 연장신청'
      if (const_val === CONSULT_ACTION.LEAVE) return '(PUSH) 상담종료'
      if (const_val === CONSULT_ACTION.CANCEL) return '상담 취소 버튼을 눌렸을 경우(상담받기전)'
    },
    gender_text (const_val) {
      if (const_val === undefined) return '' // 데이터가 존재하지 않는경우
      return (const_val === 'M') ? '남자' : '여자'
    },
    drinking_text (is_drinking) {
      if (!is_drinking || is_drinking === undefined) return '안함' // 데이터가 존재하지 않는경우
      return is_drinking ? '자주(주2회이상)' : '가끔(주1회미만)'
    },
    smoking_text(is_smoking) {
      if (is_smoking === undefined) return '' // 데이터가 존재하지 않는경우
      return (is_smoking) ? '흡연' : '비흡연'
    },
    img_title_view(img_name) {
      if(!img_name) return '프로필 사진을 반드시 등록해 주세요.';
      else if(img_name.includes('null')) return '프로필 사진을 반드시 등록해 주세요.';
      else return '';
    },
    set_substr(str, str_len) {
      if(str && str.length>str_len) str = str.substr(0,str_len) + "...";
      return str;
    },
    async popupCenter(url, title, w, h, t, l) {
      const dualScreenLeft = window.screenLeft !==  undefined ? window.screenLeft : window.screenX;
      const dualScreenTop = window.screenTop !==  undefined   ? window.screenTop  : window.screenY;

      const width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
      const height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;

      const systemZoom = width / window.screen.availWidth;
      const left = (!l) ? (width - w) / 2 / systemZoom + dualScreenLeft : (width - w) / 2 / systemZoom + dualScreenLeft - l
      const top = (height - h) / 2 / systemZoom + dualScreenTop
      const newWindow = window.open(url, title, 
      `
      scrollbars=yes,
      width=${w / systemZoom}, 
      height=${h / systemZoom}, 
      top=${top}, 
      left=${left}
      `
      )

      if (window.focus) newWindow.focus();
    },
    is_mobile() {
      if( screen.width <= 1024 ) {
          return true;
      }
      else {
          return false;
      }
    },
    keyDown_numberOnly : function (e) {
      
      var key;
      if(window.event)
          key = window.event.keyCode; //IE
      else
          key = e.which; //firefox
      var event;
      if (key == 0 || key == 8 || key == 46 || key == 9){
          event = e || window.event;
          if (typeof event.stopPropagation != "undefined") {
              event.stopPropagation();
          } else {
              event.cancelBubble = true;
          }   
          return;
      }

      if (key < 48 || (key > 57 && key < 96) || key > 105 || e.shiftKey) {
        // console.log('key1', key)    
          //e.preventDefault ? e.preventDefault() : e.returnValue = false;
          e.returnValue = false;
      } else {
        e.returnValue = true;
      }
    },        
    keyUp_numberOnly : function (e) {
        var key;
        if(window.event)
            key = window.event.keyCode; //IE
        else
            key = e.which; //firefox
        var event;
        event = e || window.event; 
        // console.log('key2', key)       
        if ( key == 8 || key == 46 || key == 37 || key == 39 ) 
            return;
        else if ((key > 31 && (key < 48 || key > 57)) && key !== 46) {
          // console.log('key3', key)  
          if((key < 96 || key > 105)){ // 오른쪽 숫자 키패드의 숫자 제외
            event.target.value = event.target.value.replace(/[^0-9]/g, ""); //숫자 이외 제거함
          }
        }
    },
    focusOut_numberOnly : function (ele) {
        ele.val(ele.val().replace(/[^0-9]/g, ""));
    },
    set_phone_format(phone) {
      // console.log("phone===============", phone);
      // if(phone) {
      //   if(phone.length==11)
      //     return phone.replace(/[^0-9]/g, '')
      //                 .replace(/(\d{3})(\d{4})(\d{4})/, '$1-$2-$3');
      //   else if (phone.length==10)
      //     return phone.replace(/[^0-9]/g, '')
      //                 .replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3');
      //   else if (phone.length==9)
      //     return phone.replace(/[^0-9]/g, '')
      //                 .replace(/(\d{2})(\d{3})(\d{4})/, '$1-$2-$3');
      //   else
      //     return phone;    
      // } else {
      //   return '';
      // }
    }
    

  }
}